import { Link } from 'react-router-dom';
import {
  BookOpen,
  BarChart2,
  Users,
  Star,
  Grid,
  TrendingUp,
} from 'lucide-react';
import styles from './ReportsPage.module.css';

const REPORTS = [
  {
    to: '/reports/bookings',
    icon: BookOpen,
    title: 'Bookings',
    description: 'Day-by-day tee time and player details with collapsible booking rows and print support.',
  },
  {
    to: '/reports/occupancy',
    icon: BarChart2,
    title: 'Occupancy rate',
    description: 'Tee time utilization trends over a date range, with day and time-of-day breakdowns.',
  },
  {
    to: '/reports/players',
    icon: Users,
    title: 'Player list',
    description: 'Filterable and sortable list of all players with their booking details and status.',
  },
  {
    to: '/reports/top-members',
    icon: Star,
    title: 'Top members',
    description: 'Members ranked by paid booking count with expandable booking history.',
  },
  {
    to: '/reports/heatmap',
    icon: Grid,
    title: 'Heatmap',
    description: 'Visual occupancy heatmap by date and hour in week or month view.',
  },
  {
    to: '/reports/bookings-chart',
    icon: TrendingUp,
    title: 'Bookings chart',
    description: 'Line chart of bookings over time with day, week, or month granularity.',
  },
];

export default function ReportsPage() {
  return (
    <div className={styles.page}>
      <div className={styles.header}>
        <h1 className={styles.title}>Reports</h1>
        <p className={styles.subtitle}>Select a report to view data for your golf courses.</p>
      </div>
      <div className={styles.grid}>
        {REPORTS.map((rpt) => {
          const Icon = rpt.icon;
          return (
            <Link key={rpt.to} to={rpt.to} className={styles.card}>
              <div className={styles.cardIconWrap}>
                <Icon size={20} strokeWidth={1.5} />
              </div>
              <div className={styles.cardBody}>
                <div className={styles.cardTitle}>{rpt.title}</div>
                <div className={styles.cardDesc}>{rpt.description}</div>
              </div>
              <div className={styles.cardArrow}>View report →</div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
